import { MainMapConfig } from '../../../app/config/model/mainmap-config.model';

export const MAIN_MAP_CONFIG: MainMapConfig = {
  toleranceInPixel: 10,
  zoomFactor: 2.5,
  extent: {
    xmin: 2488000,
    ymin: 1070000,
    xmax: 2830000,
    ymax: 1300000,
    spatialReference: {
      wkid: 2056,
    },
  },
  zoomSlider: {
    range: {
      min: 250,
      '10%': 500,
      '20%': 1000,
      '30%': 5000,
      '40%': 10000,
      '50%': 25000,
      '60%': 100000,
      '70%': 250000,
      '80%': 500000,
      '90%': 750000,
      max: 1000000,
    },
  },
  marker: {
    url: './assets/images/marker.png',
    width: '30px',
    height: '30px',
  },
  edit: {
    symbols: {
      polygon: {
        color: [255, 255, 0, 0.25],
        style: 'solid',
        outline: {
          color: [255, 0, 0],
          width: 3,
        },
      },
      polyline: {
        color: [255, 0, 0],
        width: 3,
        style: 'solid',
      },
      point: {
        color: [255, 255, 0, 0.25],
        size: '16px',
        outline: {
          color: [255, 0, 0],
          width: 3,
        },
      },
    },
  },
  printGraphic: {
    symbols: {
      polygon: {
        color: [255, 255, 0, 0.25],
        style: 'solid',
        outline: {
          color: [255, 0, 0],
          width: 2,
        },
      },
    },
  },
  draw: {
    symbols: {
      polygon: {
        color: [178, 102, 234, 0.8],
        style: 'solid',
        outline: {
          color: [178, 102, 234],
          width: 2,
        },
      },
      polyline: {
        color: [178, 102, 234],
        width: 2,
        style: 'solid',
      },
      point: {
        style: 'circle',
        color: [178, 102, 234],
        size: '16px',
        outline: {
          color: [178, 102, 234],
          width: 2,
        },
      },
    },
  },
  select: {
    symbols: {
      polygon: {
        color: [0, 254, 254, 0.3],
        style: 'solid',
        outline: {
          color: [0, 254, 254],
          width: 2,
        },
      },
      polyline: {
        color: [0, 254, 254],
        width: 2,
        style: 'solid',
      },
      point: {
        style: 'circle',
        color: [0, 254, 254, 0.3],
        size: '16px',
        outline: {
          color: [0, 254, 254],
          width: 2,
        },
      },
    },
  },
  goTo: {
    scale: 3000,
    flash: {
      time: 800,
      symbol: {
        style: 'circle',
        color: [255, 0, 0, 0.3],
        outline: {
          color: [170, 0, 0],
          width: '3px',
        },
        size: '50px',
      },
    },
  },
  searchMarker: {
    symbol: {
      style: 'circle',
      color: [255, 0, 0, 0.3],
      outline: {
        color: [170, 0, 0],
        width: '3px',
      },
      size: '50px',
    },
  },
  tocLayers: [
    {
      fkLayer: 'parzellen_view',
      visible: false,
    },
  ],
  selectOptionsYesNo: [
    {
      name: 'COMMON.YES',
      code: 1,
    },
    {
      name: 'COMMON.NO',
      code: 0,
    },
  ],
};
